import { fetcher } from '@commenda/utils';

export async function requestMarketplaceService({
  email,
  serviceName,
}: {
  serviceName: string;
  email: string;
}) {
  const response = await fetcher('marketplace/service-requests/request', {
    method: 'POST',
    body: { email, serviceName },
  });

  return response;
}
